import React from "react";

const FULL_SLOTS_DAYS = 35;

export const CalendarPopupSkeleton = () => (
  <>
    {Array.from({ length: FULL_SLOTS_DAYS }, (_, index) => (
      <div
        key={`skeleton-${index}`}
        className="flex h-10 items-center justify-center"
      >
        <div className="size-10 animate-pulse rounded-full bg-gray-200" />
      </div>
    ))}
  </>
);
